"use client";

import Grid from "@mui/material/Grid";
import useTheme from "@mui/material/styles/useTheme"; // CUSTOM ICON COMPONENTS

import { H4, Span } from "src/lib/components/salify-next-layout/default/components/Typography";

// STYLED COMPONENTS
import { SectionContainer, StyledFlexBox, IconBox } from "./styles"; // ==================================================

// ==================================================
const ServiceList = ({ serviceList = [] }) => {
  const { palette } = useTheme();
  const servicesData = serviceList.slice(0, 3);
  return servicesData?.length ? (
    <SectionContainer>
      <Grid container spacing={3}>
        {servicesData.map((item, ind) => {
          // const Icon = appIcons[item.icon];
          return (
            <Grid item md={4} sm={6} xs={12} key={ind}>
              <StyledFlexBox gap={1.5}>
                <IconBox>
                  {/*  <Icon fontSize="50px" sx={{*/}
                  {/*  color: palette.primary.main*/}
                  {/*}}>*/}
                  {/*{item.icon}*/}
                  {/*</Icon>*/}
                </IconBox>

                <div>
                  <H4 mb="5px" fontSize="1rem" fontWeight="600">
                    {item.title}
                  </H4>
                  <Span color="grey.600">{item.description}</Span>
                </div>
              </StyledFlexBox>
            </Grid>
          );
        })}
      </Grid>
    </SectionContainer>
  ) : null;
};

export default ServiceList;
